import React from 'react';

// MyHR Orbit Logo Component
export const LogoIcon = ({ className = "h-8 w-8" }) => (
  <svg
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Outer orbital ring */}
    <circle
      cx="50"
      cy="50"
      r="45"
      stroke="url(#gradient1)"
      strokeWidth="2"
      fill="none"
      opacity="0.6"
    />
    
    {/* Middle orbital ring */}
    <circle
      cx="50"
      cy="50"
      r="35"
      stroke="url(#gradient2)"
      strokeWidth="2"
      fill="none"
      opacity="0.8"
    />
    
    {/* Inner orbital ring */}
    <circle
      cx="50"
      cy="50"
      r="25"
      stroke="url(#gradient3)"
      strokeWidth="2"
      fill="none"
    />
    
    {/* Central core circle */}
    <circle
      cx="50"
      cy="50"
      r="18"
      fill="url(#gradientCore)"
    />
    
    {/* HR text in center */}
    <text
      x="50"
      y="50"
      textAnchor="middle"
      dominantBaseline="central"
      fill="white"
      fontSize="16"
      fontWeight="bold"
      fontFamily="system-ui, -apple-system, sans-serif"
    >
      HR
    </text>
    
    {/* Orbiting dots */}
    <circle cx="50" cy="5" r="3" fill="#10B981" opacity="0.8" />
    <circle cx="95" cy="50" r="3" fill="#14B8A6" opacity="0.8" />
    <circle cx="50" cy="95" r="3" fill="#06B6D4" opacity="0.8" />
    <circle cx="5" cy="50" r="3" fill="#10B981" opacity="0.8" />
    
    {/* Gradients */}
    <defs>
      <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#14B8A6" stopOpacity="0.6" />
      </linearGradient>
      <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#14B8A6" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#06B6D4" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#06B6D4" />
      </linearGradient>
      <linearGradient id="gradientCore" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="50%" stopColor="#14B8A6" />
        <stop offset="100%" stopColor="#06B6D4" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoFull = ({ className = "", onClick }) => (
  <div 
    className={`flex items-center space-x-2 cursor-pointer ${className}`}
    onClick={onClick || (() => window.location.href = '/')}
  >
    <LogoIcon className="h-8 w-8" />
    <div className="flex flex-col leading-tight">
      <span className="text-xl font-bold text-slate-900 dark:text-white">MyHR</span>
      <span className="text-sm font-medium text-emerald-400">Orbit</span>
    </div>
  </div>
);

export const LogoFullHorizontal = ({ className = "", onClick }) => (
  <div 
    className={`flex items-center space-x-2 cursor-pointer ${className}`}
    onClick={onClick || (() => window.location.href = '/')}
  >
    <LogoIcon className="h-8 w-8" />
    <div className="flex items-baseline space-x-1">
      <span className="text-xl font-bold text-slate-900 dark:text-white">MyHR</span>
      <span className="text-xl font-bold text-emerald-400">Orbit</span>
    </div>
  </div>
);

export default LogoFull;
